import { DatePipe } from '@angular/common';
import { Utils } from './../../../../../utils/utils';
import { TechTableInfoModalComponent } from './../../../../../shared/tech-table-info-modal/tech-table-info-modal.component';
import {
  TechTableInfoItemModel,
  TechTableInfoModel,
} from './../../../../../core/models/tech-table-info.model';
import { MatDialog } from '@angular/material/dialog';
import {
  DoublePipe,
  CurrencySignusPipe,
  CurrencyPipe,
  PercentPipe,
  PercentSignusPipe,
  DashEmptyPipe,
} from '@techrules/pipelib';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { timer, Subject } from 'rxjs';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { environment } from '@tech-environments/environment';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators';
import { MatTooltip } from '@angular/material/tooltip';
import { animate, style, transition, trigger } from '@angular/animations';
import { DeviceDetectorService } from '@techrules/portallib';
import { SessionService } from '@tech-services/session.service';
import { faFileChartLine } from '@fortawesome/pro-light-svg-icons';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from 'projects/apps/portal-client/src/app/shared/tech-dialogs.service';

@Component({
  selector: 'tech-portfolio-positions',
  templateUrl: './portfolio-positions.component.html',
  styleUrls: [
    './portfolio-positions.component.scss',
    '../portfolio-data-shared-styles.scss',
  ],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [style({ height: 0 }), animate(500)]),
      transition(':leave', [animate(500, style({ height: 0 }))]),
    ]),
  ],
})
export class PortfolioPositionsComponent implements OnInit, OnDestroy {
  public openMoreData = true;

  @ViewChild('dropdown', { static: true }) dropdown: ElementRef;
  @ViewChild('tableAssets', { static: true }) tableAssets: ElementRef;
  @ViewChild('positionsTooltip', { static: false })
  positionsTooltip: MatTooltip;
  @ViewChild('assetsTooltip', { static: false }) assetsTooltip: MatTooltip;
  private unsubscribe$ = new Subject<void>();
  loadingPositions: boolean;
  moreOf: boolean = false;
  tableMoreOf: boolean = false;
  showPosition2: boolean = false;
  dataPositions: any;
  dataPositionsCash: any;
  dataPositions2: any;
  cols: any;
  positions: any;
  dateFormat = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');
  private timer3s = timer(3000);

  private listenerFnClicks: () => void;
  private listenerFnHovers: () => void;

  public colsTrades = [];

  isMobile: boolean;
  bgColors = Utils.LogoNameFirstColor;

  /* Icons */
  faFileChartLine = faFileChartLine;

  //investmentLab
  investmentLab: boolean;
  //Show fieldISINClientPortal
  fieldISINClientPortal: boolean;

  constructor(
    private deviceService: DeviceDetectorService,
    private profilePortfolioService: ProfileportfolioService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    public dialog: MatDialog,

    private doublePipe: DoublePipe,
    private percentPipe2: PercentSignusPipe,
    private currencyPipe: CurrencyPipe,
    private currencySignusPipe: CurrencySignusPipe,
    private percentPipe: PercentPipe,
    private sessionService: SessionService,
    private datePipe: DatePipe,
    private dashEmptyPipe: DashEmptyPipe
  ) {
    this.dataPositions = [];
    this.dataPositionsCash = [];
    this.dataPositions2 = [];
  }

  /**
    Función para crear las columnas en las tablas
  */
  initTableColums() {
    if (this.isMobile) {
      this.colsTrades = [
        {
          dataField: 'Name',
          width: '50%',
          cssClass: 'td-250',
          cellTemplate: 'templateMobile',
          hidingPriority: 0,
        },
      ];
    } else {
      this.colsTrades = [
        {
          dataField: 'Name',
          caption: this.translate.instant('k000036'),
          width: '50%',
          cellTemplate: 'templateName',
          hidingPriority: 1,
        },
        {
          type: 'detailExpand',
        },
      ];
    }
  }

  @HostListener('window:resize') onresize() {
    this.isMobile = this.deviceService.isMobile();
    this.initTableColums();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();

    this.loadingPositions = true;

    this.dataPositions = [];
    this.dataPositionsCash = [];
    this.dataPositions2 = [];

    this.profilePortfolioService.portfolioData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.loadPositions();
      });

    this.profilePortfolioService.portfolioanalysisPositions$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.profilePortfolioService.portfolioanalysisPositions = data;
        this.loadingPositions = true;
        this.loadPositions();
        this.initTableColums();
      });
    this.profilePortfolioService.periodSelected$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (Object.keys(res).length !== 0) {
          this.loadingPositions = true;
          this.profilePortfolioService.updatePositions();
        }
      });

    this.investmentLab = AppConfig.settings.investmentLab;
    this.fieldISINClientPortal = AppConfig.settings.fieldISINClientPortal;
  }

  getRandomBgColor() {
    return Math.floor(Math.random() * 9);
  }

  /**
    Función para abrir popup del detalle modo mobile
  */
  openDetailPosition(item) {
    let items: TechTableInfoItemModel[] = [];
    items.push(new TechTableInfoItemModel('k000085', item.AssetClassName));

    items.push(
      new TechTableInfoItemModel(
        'k000543',
        this.currencyPipe.transform(item.Valuation, item.ValuationCurrency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k001809',
        this.currencyPipe.transform(item.CostValue, item.ValuationCurrency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k000296',
        this.doublePipe.transform(
          item.NumberOfShares,
          item.Behaviour === 'S' || item.Behaviour === '8' ? '1.2-2' : '1.6-6'
        )
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k000048',
        this.currencyPipe.transform(item.AssetPrice, item.AssetCurrency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k002871',
        this.datePipe.transform(item.AssetPriceDate, this.dateFormat)
      )
    );
    if (item.Behaviour == 'B' && item.MaturityDate) {
      items.push(
        new TechTableInfoItemModel(
          'k004198',
          this.datePipe.transform(item.MaturityDate, this.dateFormat)
        )
      );
    }
    items.push(
      new TechTableInfoItemModel(
        'k004197',
        this.currencySignusPipe.transform(
          item.UnrealizedGains,
          item.ValuationCurrency
        ) +
          ' | ' +
          this.percentPipe2.transform(item.UnrealizedGainsPercent)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k001692',
        this.percentPipe.transform(item.Weight)
      )
    );
    if (this.fieldISINClientPortal) {
      items.push(
        new TechTableInfoItemModel(
          'k000159',
          this.dashEmptyPipe.transform(item.Isin)
        )
      );
    }
    var dialogData;
    if (this.investmentLab) {
      let url = this.getTReportURL(item.Id);
      dialogData = new TechTableInfoModel(item.Name, items, url);
    } else {
      dialogData = new TechTableInfoModel(item.Name, items);
    }

    const dialogRef = this.dialog.open(TechTableInfoModalComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      panelClass: [
        'dialogfluid-intocenter',
        'tranimate__animated',
        'tranimate__slideInRight',
      ],
      data: dialogData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  getTReportURL(id): string {
    const url = new URL(AppConfig.settings.angularAppsBase + '/asset');
    url.searchParams.set('AssetId', id);
    url.searchParams.set('Domain', AppConfig.settings.domain);
    url.searchParams.set('Language', AppConfig.settings.language);
    url.searchParams.set('ToolsToken', AppConfig.settings.toolsToken);
    return url.toString();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    if (this.listenerFnClicks) this.listenerFnClicks();
    if (this.listenerFnHovers) this.listenerFnHovers();
  }

  /**
      Función para colocar un border a la izquierda en modo Desktop
    */
  onRowExpanded(e) {
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const el = grid.getRowElement(row)[0];
    const detail = grid.getRowElement(row + 1)[0];
    //const animArr = detail.getElementsByClassName('detailswrapper');
    //const anim = animArr[0];
    el.classList.add('borderleft');
    detail.classList.add('borderleft');
    //anim.classList.add('opendetails_animation');
    grid.selectRows(e.key);
  }

  /**
    Función para colocar un sombreado sobre la fila de la tabla
  */
  onRowClick(e) {
    const key = e.component.getKeyByRowIndex(e.rowIndex);
    const expanded = e.component.isRowExpanded(key);
    if (e.rowType != 'detail') {
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.command === 'expand') {
      e.cellElement.classList.remove('dx-datagrid-expand');
    }
  }

  onRowCollapsed(e) {
    const grid = e.component;
    grid.selectRows(e.key);
  }

  onRowExpanding(e) {
    /*
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const arr = grid.getRowElement(row + 1);
    if (arr) {
      const detail = arr[0];
      const animArr = detail.getElementsByClassName('detailswrapper');
      const anim = animArr[0];
      anim.classList.remove('closedetails_animation');
      anim.classList.add('opendetails_animation');
      //this.toggleSlide(anim);
    }*/
  }

  onRowCollapsing(e) {
    /*
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const detail = grid.getRowElement(row + 1)[0];
    const animArr = detail.getElementsByClassName('detailswrapper');
    const anim = animArr[0];
    anim.classList.remove('closedetails_animation');
    anim.classList.remove('opendetails_animation');
    anim.classList.add('closedetails_animation');
    */
    //anim.style.height = '500px';
    //this.toggleSlide(anim);
  }
  /*
  toggleSlide = function(el) {
  var minheight = 0;
  var maxheight = 500;
  var time = 1000;
  var timer = null;
  var toggled = true;

  clearInterval(timer);
  var instanceheight = parseInt(el.style.height);  // Current height
  var init = (new Date()).getTime(); //start time
  var height = (toggled = !toggled) ? maxheight: minheight; //if toggled

  var disp = height - parseInt(el.style.height);
  timer = setInterval(function() {
      var instance = (new Date()).getTime() - init; //animating time
      if(instance <= time ) { //0 -> time seconds
          var pos = instanceheight + Math.floor(disp * instance / time);
          el.style.height =  pos + 'px';
      }else {
          el.style.height = height + 'px'; //safety side ^^
          clearInterval(timer);
      }
  },1);
}*/

  loadPositions() {
    this.loadingPositions = false;
    this.tableMoreOf = false;
    this.dataPositions = [];
    this.dataPositions2 = [];
    if (this.profilePortfolioService.portfolioanalysisPositions) {
      const _positions =
        this.profilePortfolioService.portfolioanalysisPositions.Positions;

      this.dataPositions = _positions.filter((item) => item.Behaviour !== 'M');
      this.dataPositionsCash = _positions.filter(
        (item) => item.Behaviour === 'M'
      );

      this.dataPositions2 =
        this.profilePortfolioService.portfolioanalysisPositions.Positions;
      this.moreOf = false;
    }
  }

  riskClick() {
    this.dialogService.openModalDialog(
      // 'info-circle',
      '',
      this.translate.instant('k000467'), //Token: info',
      this.translate.instant('k001813'), //Token: 'En términos de matematica financiera, hablamos de volatilidad a la medida de la frecuencia e intensidad de los cambios del precio de un activo o de un tipo definido como la desviación estándar de dicho cambio en un horizonte temporal específico, un año en este caso. Esta medida es habitual para cuantificar el riesgo del instrumento.',
      ''
    );
  }

  ratioClick() {
    this.dialogService.openModalDialog(
      // 'info-circle',
      '',
      this.translate.instant('k000467'), //Token: info',
      this.translate.instant('k001814'), //Token: Hablamos de ratio a la medida que resulta de dividir la rentabilidad anual del activo menos la de un activo “libre” de riesgo, dividido por la volatilidad anual.
      ''
    );
  }

  positionsTooltipShow(event) {
    this.positionsTooltip.show();
    this.timer3s.subscribe(() => {
      this.positionsTooltip.hide();
    });
  }

  getColorById(id): string {
    return Utils.getColorById(id);
  }

  /*
  Función para mostrar el TReport del activo
  */
  goTReport(stockId) {
    if (stockId != undefined) {
      const url = new URL(AppConfig.settings.angularAppsBase + '/asset');
      url.searchParams.set('AssetId', stockId);
      url.searchParams.set('Domain', AppConfig.settings.domain);
      url.searchParams.set('Language', AppConfig.settings.language);
      url.searchParams.set('ToolsToken', AppConfig.settings.toolsToken);
      window.open(url, '_blank');
    }
  }
}
